import { css } from '@bts-web/utils-style-engine';

const ListCellsSelectionCheckboxIndicator = ({
  checked,
  isDisabled = false,
}: {
  checked: boolean;
  isDisabled?: boolean;
}) => (
  <div
    className={css({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      width: '20px',
      height: '20px',
      borderRadius: '4px',
      border: '1.5px solid',
      borderColor: checked
        ? 'positive.fill_primary'
        : 'neutrals.text_secondary',
      backgroundColor: checked ? 'positive.fill_primary' : 'transparent',
      ...(isDisabled && {
        borderColor: 'neutrals.text_disabled',
      }),
    })}
    aria-hidden="true"
  >
    {checked && (
      <div
        className={css({
          display: 'block',
          width: '6px',
          height: '12px',
          transform: 'rotate(45deg)',
          borderBottom: '1.5px solid',
          borderInlineEnd: '1.5px solid',
          borderColor: 'neutrals.text_primary_inverted',
          marginBottom: '4px',
        })}
      />
    )}
  </div>
);

export { ListCellsSelectionCheckboxIndicator };
